import React, { Component } from "react";
import "./Courses.scss";
import CourseList from "./course-list/Course_list";
import { NavLink } from "react-router-dom";

class Courses extends Component {
  constructor() {
    super();
    this.scrollPage();
  }

  scrollPage() {
    window.scrollTo({
      top: 0
    });
  }
  render() {
    return (
      <div className="courses">
        {/* page 1 */}
        {/* <section className="page1">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="heading">
                  <h1>Courses</h1>
                  <p>
                    We are known for creating courses on latest technologies
                    with projects. This gives students a confidence in learning.
                    You can learn coding only by building stuff.
                  </p>
                </div>
              </div>
              <div className="col-md-6 pageonelogo">
                <img src={require("../../images/courses img.png")} alt="" />
              </div>
            </div>
          </div>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-md-3">
                <div className="page-1-info">
                  <div className="icon">
                    <img
                      src={require("../../images//trophy icon.png")}
                      alt=""
                    />
                  </div>

                  <div className="info">
                    <h1>Top Courses</h1>
                    <p>
                      Get the finest advance courses that are in demand now.
                    </p>
                    <NavLink to="/contact" activeClassName="active">
                      Join Us
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="page-1-info">
                  <div className="icon">
                    <img
                      src={require("../../images/placement icon.png")}
                      alt=""
                    />
                  </div>

                  <div className="info">
                    <h1>Upcoming Events</h1>
                    <p>online courses</p>
                    <NavLink to="/contact" activeClassName="active">
                      Join Us
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        
        {/* page 2 */}
        <section className="page2">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="page2_heading">
                  <h1>In-demand courses:</h1>
                  <h3>
                    Logipool Offers a Choice Of Different 
                    Courses.
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <CourseList />
        </section>
      </div>
    );
  }
}

export default Courses;
